module.exports = __webpack_public_path__ + "static/media/branding-logo-topbar.e487f873.png";